import { FC, memo, useEffect, useRef } from 'react'

import { Loader } from 'components'

type Props = {
  children: JSX.Element
  isLoading?: boolean
  loadingText?: string
  loadMore: () => void
}

const InfiniteScroll: FC<Props> = ({
  isLoading = false,
  loadingText = 'Carregando',
  children,
  loadMore,
}) => {
  const containerRef = useRef<HTMLDivElement | null>(null)

  useEffect(() => {
    const options = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        observer.disconnect()
        loadMore()
      }
    }, options)

    if (containerRef.current) observer.observe(containerRef.current)

    return () => {
      observer.disconnect()
    }
  }, [isLoading])

  return (
    <>
      {children}

      {isLoading ? (
        <Loader height="100px" text={loadingText} />
      ) : (
        <div ref={containerRef} />
      )}
    </>
  )
}

export default memo(InfiniteScroll)
